<template>
	<div id="loading-spinner" v-show="loading">
		<div>
			<div class="m-2">
				<i class="fas fa-spinner fa-3x color-white-1 fa-spin"></i>
			</div>
			<span class="font-14 color-white-1">{{msg}}</span>
		</div>
	</div>
</template>

<script>
	export default {
		computed: {
			loading() {
				return this.$store.state.loading
			},
			msg() {
				return this.$store.state.msgLoading
			}
		}
	}
</script>

<style>
	#loading-spinner {
		position: fixed;
		top:0px;
		width: 100%;
		height: 100%;
		background: rgba(51, 81, 152, 0.7);
		text-align: center;
		vertical-align: middle;
		padding: 25%;
		z-index: 100000;
	}

	/* #loading-spinner:-webkit-full-screen,
	#loading-spinner:-moz-full-screen,
	#loading-spinner:-ms-fullscreen,
	#loading-spinner:fullscreen {
		width: 100vw;
		height: 100vh;
    } */
</style>